const { VITE_CONVERSATIONS_API } = import.meta.env;

/**
 * Per-user preferences on the conversations service. The trailing slash matches
 * the backend route (`/api/ai/v1/preferences/`) so the request hits
 * it directly instead of relying on a 307 slash redirect.
 */
export const userPreferencesPath = () => `${VITE_CONVERSATIONS_API}/preferences/`;

export interface UserPreferencesResponse {
  /** ISO timestamp of when the user accepted the MCP guidelines, or `null` if
   *  they never have. */
  mcp_guidelines_accepted_at: string | null;
  /** Whether agents may read and write this user's memories. The service
   *  resolves the never-chosen case to its default, so this is always a
   *  boolean. */
  memories_enabled: boolean;
  /** The user's own standing instructions to the agents, or `null` if they have
   *  never written any. */
  personalization: string | null;
}

/** Every field is optional: an omitted field leaves that preference untouched,
 *  so updating one never clobbers another. */
export interface UserPreferencesUpdate {
  accept_mcp_guidelines?: boolean;
  memories_enabled?: boolean;
  /** Send an empty string to clear the stored instructions. */
  personalization?: string;
}

/** Matches the service's cap, so the editor stops the user where the API would
 *  reject them. */
export const PERSONALIZATION_MAX_LENGTH = 4000;
